import { Component } from "@angular/core";

@Component({
    selector: "app-upload",
    template: "<router-outlet></router-outlet>",
})
export class UploadComponent {
    constructor() {}
}
